import React from 'react';
import { setTimeout } from 'timers';
import HelperTip from '../Form/FormHelper/HelperTip';
require('./OnePageTab.scss');

class OnePageTab extends React.Component {
    constructor(props) {
        super(props);
        this.scrollActiveStyle = this.scrollActiveStyle.bind(this);
        this.changeActiveStyle = this.changeActiveStyle.bind(this);

        this.state = {
            tabLabArr: this.props.tabLabArr || [],
            children: []
        };
    }

    componentWillMount() {
        let tempArr = [];
        this.state.tabLabArr.forEach((item, index) => {
            tempArr.push(
                <div
                    key={index}
                    className={
                        'onepagetab-item' + (index == 0 ? ' active' : '')
                    }
                    onTouchTap={this.touchHandler.bind(this, index)}>
                    <span
                        className={
                            window.env.platform.android
                                ? 'point android'
                                : 'point ios'
                        }
                    />
                    <span>{item.value}</span>
                </div>
            );
        });
        this.setState({ children: tempArr });
    }

    componentDidMount() {
        this.props.tabDidMount && this.props.tabDidMount();
    }

    scrollActiveStyle(index) {
        this.changeActiveStyle(index);
    }

    touchHandler(index, e) {
        e && e.preventDefault();
        this.changeActiveStyle(index);
        this.props.touchTapHandler && this.props.touchTapHandler(index);
    }

    changeActiveStyle(index) {
        let feedIn = document.getElementsByClassName('onepagefooter')[0];
        const feedTextarea =
            feedIn && feedIn.getElementsByClassName('footer-reply-textarea')[0];
        if (feedTextarea) {
            // 解决切换tab feed输入框不失去焦点的问题
            feedTextarea.blur();
        }
        //let footerButton = document.getElementsByClassName('page-footer')[0];
        const transformForOnePage = document.getElementsByClassName(
            'transformForOnePage'
        )[0];
        const footerButton = document.getElementsByClassName(
            'transition-wrap-detail'
        )[0];
        const transY = (footerButton && footerButton.offsetHeight) || 55;
        let specialTag = false;
        Array.prototype.slice
            .call(document.getElementsByClassName('onepagetab-item'), 0)
            .forEach((node, point) => {
                if (point == index) {
                    node.className = 'onepagetab-item active';

                    if (this.state.tabLabArr[index].key == 'feed') {
                        if (feedIn) {
                            feedIn.style.opacity = 1;
                            feedIn.style.zIndex = 2;
                        }
                        if (footerButton) {
                            footerButton.style.transform = `translateY(${transY}px)`;
                            footerButton.style.WebkitTransform = `translateY(${transY}px)`;
                        }
                    }

                    if (!specialTag) {
                        // 解决apicloud中切换白页 渲染不全的问题
                        specialTag = true;
                        setTimeout(() => {
                            transformForOnePage.style.transform =
                                'translateY(1px)';
                            transformForOnePage.style.WebkitTransform =
                                'translateY(1px)';
                        });
                    }
                } else {
                    if (specialTag) {
                        specialTag = false;
                        setTimeout(() => {
                            transformForOnePage.style.transform =
                                'translateY(0px)';
                            transformForOnePage.style.WebkitTransform =
                                'translateY(0px)';
                        });
                    } else {
                        specialTag = true;
                        setTimeout(() => {
                            transformForOnePage.style.transform =
                                'translateY(1px)';
                            transformForOnePage.style.WebkitTransform =
                                'translateY(1px)';
                        });
                    }
                    node.className = 'onepagetab-item';

                    if (feedIn) {
                        feedIn.style.opacity = 0;
                        feedIn.style.zIndex = 0;
                    }
                    if (footerButton) {
                        footerButton.style.transform = 'translateY(0)';
                        footerButton.style.WebkitTransform = 'translateY(0)';
                    }
                }
            });
    }

    render() {
        const isInApp =
            window.env.platform.beisenApp ||
            window.env.platform.weixin ||
            window.env.platform.dingTalk;
        return (
            <div className={`onepagetab${isInApp ? ' app' : ''}`}>
                <div className="onepagetab-child-box">
                    {this.state.children}
                </div>
            </div>
        );
    }
}
export default OnePageTab;



// WEBPACK FOOTER //
// ./src/components/DetailPage/OnePageTab.js